import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import FieldsSection from '../../../../components/Form/Field/FieldsSection'
import FieldRow from '../../../../components/Form/FieldRow'
import Field from '../../../../components/Form/Field'
import MultipleOptionsField from '../../../ReusableFormFields/MultipleOptionsField'
import Checkbox from '../../../../components/Form/Checkbox'

import {
  BLOCK_UNRATED_URLS,
  blockUnrateableOptions,
  CUSTOM_SEGMENT_IDS,
  EXCLUDE_UNRATEABLE,
  SAFETY_OPTIONS,
  safetyEnumsOptions,
  safetyOptions
} from '../../UploadDV360AdCreative/UploadDV360AdCreativeForm/LineItemForm/fields'

import useStyles from './styles'

const ThirdPartyVerificationFieldsSections = ({ formik }) => {
  const { t } = useTranslation()

  const classes = useStyles()

  const { values, setFieldValue } = formik

  const blockUnratedUrlsCheckboxHandler = useCallback(() => {
    setFieldValue(BLOCK_UNRATED_URLS, !values[BLOCK_UNRATED_URLS])
  }, [setFieldValue, values])

  return (
    <>
      <FieldsSection>
        {safetyOptions.map(({ value, label }) => {
          const fieldPath = `${SAFETY_OPTIONS}.${value}`
          return (
            <FieldRow title={label} rightSideClassName={classes.rightSide}>
              <Field
                options={safetyEnumsOptions}
                formik={formik}
                id={fieldPath}
                name={fieldPath}
                placeholder={label}
                className={classes.safetySelect}
              />
            </FieldRow>
          )
        })}
        <FieldRow title={'Exclude Unrateable'} rightSideClassName={classes.rightSide}>
          <Field
            options={blockUnrateableOptions}
            formik={formik}
            id={EXCLUDE_UNRATEABLE}
            name={EXCLUDE_UNRATEABLE}
            placeholder="Exclude Unrateable"
            className={classes.safetySelect}
          />
        </FieldRow>
      </FieldsSection>
      <FieldsSection>
        <h3>Context Control: Custom Segment IDs</h3>
        <MultipleOptionsField
          fieldLabel="Segment ID"
          listFieldName={CUSTOM_SEGMENT_IDS}
          formik={formik}
          maxListQuantity={null}
          type="number"
          thousandSeparator={false}
          decimalScale={0}
          maxLength={7}
          showMaxLengthMessage={false}
        />
        <Checkbox
          id="checkbox_exclude_unrateable"
          title={t('Block unrated URLs')}
          isLarge
          checked={values[BLOCK_UNRATED_URLS]}
          onCheck={blockUnratedUrlsCheckboxHandler}
          className={classes.excludeUnrateableUrlsCheckbox}
        />
      </FieldsSection>
    </>
  )
}

export default ThirdPartyVerificationFieldsSections
